import clsx from 'clsx'
import { defineComponent, type StyleValue } from 'vue'

interface Props {
  tData?: string
  class?: unknown
  style?: StyleValue
}

export default defineComponent<Props>((props, context) => {
  return () => (
    <th
      class={clsx(
        'p-1.5 px-4',
        [props.class]
      )}
    >
      <div
        t-data={props.tData}
        class='flex items-center space-x-1 whitespace-nowrap'
        style={props.style}
      >
        <span class='text-subtitle-2'>{context.slots.default?.()}</span>
      </div>
    </th>
  )
}, {
  name: 'VTableHeaderCell',
  props: ['tData', 'class', 'style']
})
